var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlayQuestion1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__a)",
  d: "M20.034 24H2.641c-.81 0-1.465-.656-1.465-1.465V1.465C1.176.656 1.832 0 2.64 0h17.393c.81 0 1.466.656 1.466 1.465v21.07c0 .809-.657 1.465-1.466 1.465Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__b)",
  d: "M21.497 22.535V2.875l-1.31-1.31a1.319 1.319 0 0 0-1.011-.47H3.494c-.73 0-1.322.592-1.322 1.322v19.167c0 .405.183.768.47 1.01L4.048 24H20.03c.81 0 1.466-.656 1.466-1.465Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__c)",
  d: "M1.176 18.857v3.678c0 .81.656 1.465 1.465 1.465h17.393c.81 0 1.466-.656 1.466-1.465v-3.678H1.176Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__d)",
  d: "M15.35.295A.831.831 0 0 0 14.716 0H7.951a.834.834 0 0 0-.834.834v1.092c0 .254.115.482.295.635l4.827 4.827c.153.18.38.295.636.295h6.764c.46 0 .834-.374.834-.834V5.757a.831.831 0 0 0-.295-.635L15.35.295Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__e)",
  d: "M19.176 22.906H3.494c-.73 0-1.322-.592-1.322-1.322V2.417c0-.73.592-1.322 1.322-1.322h15.682c.73 0 1.322.592 1.322 1.322v19.167c0 .73-.592 1.322-1.322 1.322Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__f)",
  d: "M20.178 5.122 16.15 1.095H7.117v.83c0 .256.115.484.295.637l4.827 4.826c.153.18.38.295.636.295h6.764c.46 0 .834-.373.834-.834V5.758a.832.832 0 0 0-.295-.636Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__g)",
  d: "M3.494 22.905h15.682c.73 0 1.322-.591 1.322-1.321v-1.367l-2.515-2.515a1.318 1.318 0 0 0-.979-.433H2.172v4.314c0 .73.592 1.323 1.322 1.323Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__h)",
  d: "M17.004 17.269H1.322C.592 17.269 0 17.86 0 18.59v1.742a2.572 2.572 0 0 0 2.572 2.573h16.735a.982.982 0 0 1-.981-.982v-3.333c0-.73-.592-1.322-1.322-1.322Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#766BF2",
  d: "M4.324 8.285h14.022v.767H4.324v-.767ZM4.324 11.304h14.022v.766H4.324v-.766ZM4.324 14.322H15.49v.767H4.324v-.767Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__i)",
  d: "M15.04 2.137h-.767v.74c0 .508-.413.92-.92.92h-3.36l-1.597-1.66h-.767v.74c0 .484.205.92.532 1.228l3.632 3.633c.308.327.744.531 1.228.531h4.037c.93 0 1.686-.756 1.686-1.686v-.741L15.04 2.137Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#211E43",
  d: "M13.353 4.564H9.316c-.93 0-1.687-.756-1.687-1.687v-.74h.767v.74c0 .508.412.92.92.92h4.036c.508 0 .92-.412.92-.92v-.74h.767v.74c0 .93-.756 1.687-1.686 1.687Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#PlayQuestion1_svg__j)",
  d: "M14.715 2.76H7.951a.834.834 0 0 1-.834-.834V.834c0-.46.374-.834.834-.834h6.764c.46 0 .834.374.834.834v1.092c0 .46-.373.834-.834.834Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__a",
  x1: 7.198,
  x2: 18.249,
  y1: 12,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#7326F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__b",
  x1: 20.949,
  x2: -1.307,
  y1: 21.614,
  y2: -0.642,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5AF2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#5A5AF2",
  stopOpacity: 0.039
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#5A5AF2",
  stopOpacity: 0.467
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802,
  stopColor: "#5A5AF2",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5AF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__c",
  x1: 11.338,
  x2: 11.338,
  y1: 21.924,
  y2: 25.453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E58200",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#E27F04",
  stopOpacity: 0.039
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#C15D2F",
  stopOpacity: 0.467
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802,
  stopColor: "#AD4949",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A64153"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__d",
  x1: 15.066,
  x2: 11.795,
  y1: 6.634,
  y2: -0.555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.204,
  stopColor: "#7000FF",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#7000FF",
  stopOpacity: 0.561
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__e",
  x1: 5.34,
  x2: 22.138,
  y1: 2.989,
  y2: 28.24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFCF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#FAF8F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.404,
  stopColor: "#ECEEF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.635,
  stopColor: "#D5DCEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#B5C4DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1B5D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__f",
  x1: 14.105,
  x2: 12.061,
  y1: 4.986,
  y2: -2.544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1B5D8",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.551,
  stopColor: "#899AB2",
  stopOpacity: 0.553
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#748290"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__g",
  x1: 16.331,
  x2: 10.428,
  y1: 26.169,
  y2: 20.266,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1B5D8",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.034,
  stopColor: "#9FB3D5",
  stopOpacity: 0.035
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.452,
  stopColor: "#8898AF",
  stopOpacity: 0.451
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.788,
  stopColor: "#798898",
  stopOpacity: 0.788
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#748290"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__h",
  x1: 9.654,
  x2: 9.654,
  y1: 20.237,
  y2: 24.123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F3F8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#EFF5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.404,
  stopColor: "#ECEEF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.635,
  stopColor: "#D5DCEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#A3B6D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D9ACD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__i",
  x1: 14.051,
  x2: 10.142,
  y1: 6.446,
  y2: -2.165,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1B5D8",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.551,
  stopColor: "#899AB2",
  stopOpacity: 0.553
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#748290"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PlayQuestion1_svg__j",
  x1: 11.333,
  x2: 11.333,
  y1: 0.68,
  y2: 3.234,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEB4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#DFB7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.485,
  stopColor: "#D5A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.807,
  stopColor: "#C378FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C058FF"
})))));
export { SvgPlayQuestion1 as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmQ5Y2VkOWI3ZjI1MzkxM2VhYWVmNGQ3Yzc0MDlkMjguc3ZnIjs=";